import { render } from "./DuihuanAmount.vue?vue&type=template&id=10f2b843&scoped=true"
import script from "./DuihuanAmount.vue?vue&type=script&lang=js"
export * from "./DuihuanAmount.vue?vue&type=script&lang=js"

import "./DuihuanAmount.vue?vue&type=style&index=0&id=10f2b843&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f2b843"]])

export default __exports__